import Modal from 'react-responsive-modal'

import 'react-responsive-modal/styles.css';
// custom modal styles
const modalStyle = {
  //padding: "0.2rem",
  //minHeight:          '250px',
  //minWidth:           '375px',
  width: '90%',
  maxWidth: '50rem',
  backgroundColor: 'lightgrey',
  zIndex: 1000,
}
const overlayStyle = {
  //backgroundColor: 'darkgrey',  // to get rid of opacity
}

export default function CustomModal({ children, ...props }) {
  return (
    <Modal
      styles={{
        modal: modalStyle,
        overlay: overlayStyle,
      }}
      {...props}
    >
      {children}
    </Modal>
  );
}

/*


*/
